<svelte:head>
  <link rel="icon" type="image/svg+xml" href="/alert-triangle.svg" />
</svelte:head>

<div>Page not found :(</div>
